import { render, staticRenderFns } from "./DetailModel.vue?vue&type=template&id=07526370&scoped=true"
import script from "./DetailModel.vue?vue&type=script&lang=js"
export * from "./DetailModel.vue?vue&type=script&lang=js"
import style0 from "./DetailModel.vue?vue&type=style&index=0&id=07526370&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07526370",
  null
  
)

export default component.exports